<template>
  <div class="ai-video-cn-page">
    <TopHeader class="landing-container-top" />
    <Page class="page-banner">
      <Banner />
    </Page>
    <!-- AI 生成示例 -->
    <Page class="bg-[var(--x-text-1)]">
      <GenLikeTyping />
    </Page>
    <!-- AI 视频效果 -->
    <Page class="bg-[var(--x-back-3)]">
      <AIProEffects />
    </Page>
    <Page>
      <FullyEditing />
    </Page>
    <!-- 官方元素库 -->
    <Page>
      <OfficialElement />
    </Page>
    <!-- 四种创作方式 -->
    <Page class="bg-[var(--x-back-3)]">
      <FourWaysToGo />
    </Page>
    <Page>
      <ThousandsTemplates />
    </Page>
    <Page
      class="bg-[var(--x-back-1)] border-0 border-t-[1px] border-solid border-[var(--x-back-4)]"
    >
      <Faq />
    </Page>
    <Page>
      <StartRightNow :handler="handleTrail" />
      <AppFooter />
    </Page>
  </div>
</template>

<script setup lang="ts">
import TopHeader from '~/design/widgets/top-header/index.vue';
import Page from './components/page.vue';
import AIProEffects from './modules/ai-pro-effects/index.vue';
import Banner from './modules/banner/index.vue';
import Faq from './modules/faq/index.vue';
import FourWaysToGo from './modules/four-ways-to-go/index.vue';
import FullyEditing from './modules/fully-editing/index.vue';
import OfficialElement from './modules/official-element/index.vue';
import ThousandsTemplates from './modules/thousands-templates/index.vue';

import AppFooter from '~/design/widgets/bottom-footer/footer-cn.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';

const GenLikeTyping = defineAsyncComponent(
  () => import('~/design/widgets/gen-like-typing/index-cn.vue'),
);

const handleTrail = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped src="./style/mobile.scss"></style>
<style lang="scss" scoped>
.landing-container-top {
  &:deep(.header) {
    background-color: var(--x-white-1);
  }
}
</style>
